import './generated/setupLoaders';
import { setLocale } from '@templafy/translation';

void setLocale('en-US');
